import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-circle.png'

const CircleBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default CircleBtn
